import React, { useState, useEffect } from "react";
import FlyerCarousel from './FlyerCarousel';
import "./Dashboard.css";

import play from '../assets/play.png';
import health from '../assets/health.png';
import book from '../assets/book.png';
import aerow from '../assets/aerow.png';
import { API_BASE, assetUrl } from "../apiConfig";

const API_URL = `${API_BASE}/therapist_api/get_images_data.php`;

const Navigation = ({ menuOpen, setMenuOpen }) => {
  const [FeatureData, setFeatureData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const staticFeatureConfig = [
    { id: 1, iconKey: 'assessment-start', title: 'Start Initial Client Assessment', link: "/start-assessment?appointment=Initial", iconImg: play },
    { id: 3, iconKey: 'assessment-continue', title: 'Continue Incomplete Assessment', link: "/continue-assessment", iconImg: health },
    { id: 4, iconKey: 'goals', title: 'Review Existing Goals', link: "/Goals", iconImg: aerow },
    { id: 2, iconKey: 'summaries', title: 'Set New Goal for Existing Client', link: "/start-assessment?appointment=Review", iconImg: book },
  ];

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) {
          throw new Error("Failed to fetch images");
        }
        const result = await response.json();

        const originalOrder = [
          { id: 1, iconKey: 'assessment-start', title: 'Start Initial Client Assessment', link: "/start-assessment", iconImg: play },
          { id: 2, iconKey: 'assessment-continue', title: 'Continue incomplete assessment', link: "/continue-assessment", iconImg: health },
          { id: 3, iconKey: 'summaries', title: 'Suggested Interventions', link: "/Suggested-interventions", iconImg: book },
          { id: 4, iconKey: 'goals', title: 'Review Goal and Assessments', link: "/Goals", iconImg: aerow },
        ];

        const apiImageMap = {};
        originalOrder.forEach((feature, index) => {
          const apiItem = result.data[index];
          // get_images_data.php returns a path relative to the app folder
          // ("uploads/images/x.png"), so assetUrl() prefixes it with API_BASE.
          apiImageMap[feature.id] = assetUrl(apiItem ? apiItem.image_url : "");
        });

        const mergedData = staticFeatureConfig.map((feature) => ({
          ...feature,
          image: apiImageMap[feature.id] || "",
        }));

        setFeatureData(mergedData);
      } catch (err) {
        console.error("Error fetching images:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
    // staticFeatureConfig is a module-level constant, so it never changes
    // between renders and does not belong in the dependency list.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 480 && menuOpen) setMenuOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [menuOpen, setMenuOpen]);

  return (
    <>
      <main className="dashboard-content">
        <FlyerCarousel />

        <div className="dashboard-intro">
          <p className="clinicalpath" style={{ color: "#323C43" }}>
            Clinical pathway tool to support evidence-informed early intervention
            for infants with cerebral palsy.
          </p>
        </div>

        {/* Feature Cards Grid */}
        <div className="dashboard-container">
          <div className="feature-cards-grid">

            {!loading && !error && FeatureData.map((feature, index) => (
              <div key={feature.id || index} className="feature-card-wrapper">
                <a href={feature.link} className="feature-card-link" aria-label={`${feature.title}`}>
                  <div className="card feature-card h-100">

                    <div className="feature-card-top-bg">
                      <img
                        src={feature.image}
                        className="feature-card-bg-img"
                        alt={`${feature.title}`}
                      />
                    </div>

                    <div className="feature-card-floating-icon">
                      <img src={feature.iconImg} alt="" className="feature-icon-inner" aria-hidden="true" />
                    </div>

                    <div className="feature-card-bottom-content">
                      <h3 className="feature-card-title">{feature.title}</h3>
                    </div>

                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </main>
    </>
  );
};

export default Navigation;

